module.exports = __webpack_public_path__ + "img/certifiedinstructor.73798bfd.png";